// src/hooks/useCockpitGuard.jsx

import { useAuth } from "../context/useAuth";
import { supabase } from "../utils/supabaseClient";

export default function useCockpitGuard() {
  const {
    user,
    profile,
    logout,
    loading,
    error,
  } = useAuth();

  console.log(
    "[CockpitGuard] user:",
    user
  );

  console.log(
    "[CockpitGuard] profile:",
    profile
  );

  console.log(
    "[CockpitGuard] loading:",
    loading
  );

  if (error) {
    console.error(
      "[CockpitGuard] ❌ error:",
      error.message || error
    );
  }

  // Do not block while loading
  if (loading) {
    return {
      user,
      profile,
      logout,
      loading,
      error,

      businessId: null,
      businessUUID: null,

      campaignId: null,
      groupId: null,

      toolOrder: [],

      isOwner: false,
      isAdmin: false,
      isModerator: false,

      region: "UK",
      language: "en",

      canAccess: () => false,

      updateUserSettings: async () => ({
        error: new Error(
          "Still loading"
        ),
      }),
    };
  }

  // Only block after loading completes
  if (!profile) {
    return {
      user,
      profile: null,
      logout,
      loading,
      error,

      businessId: null,
      businessUUID: null,

      campaignId: null,
      groupId: null,

      toolOrder: [],

      isOwner: false,
      isAdmin: false,
      isModerator: false,

      region: "UK",
      language: "en",

      canAccess: () => false,

      updateUserSettings: async () => ({
        error: new Error(
          "No profile available"
        ),
      }),
    };
  }

  /*
   * IMPORTANT
   *
   * businesses.id = integer PK
   * auth.users.id = uuid
   *
   * AuthProvider now injects:
   * profile.business_id
   *
   * so NEVER use profile.id here.
   */
  const businessId =
    profile?.business_id ?? null;

  const businessUUID =
    profile?.business_uuid ?? null;

  const campaignId =
    profile?.default_campaign_id ??
    null;

  const groupId =
    profile?.default_group_id ??
    null;

  const toolOrder =
    profile?.tool_order ?? [];

  const isOwner =
    profile?.user_role === "owner";

  const isAdmin =
    profile?.user_role === "admin";

  const isModerator =
    profile?.moderation_role ===
    "moderator";

  const region =
    profile?.region || "UK";

  const language =
    profile?.language || "en";

  const canAccess = (
    allowedRoles = []
  ) => {
    if (!profile?.user_role) {
      return false;
    }

    return allowedRoles.includes(
      profile.user_role
    );
  };

  const updateUserSettings =
    async (updates) => {
      if (!user?.id) {
        return {
          error: new Error(
            "No user ID available"
          ),
        };
      }

      const {
        data,
        error: updateError,
      } = await supabase
        .from("user_settings")
        .update(updates)
        .eq("user_id", user.id);

      if (updateError) {
        console.error(
          "[CockpitGuard] Failed to update user settings:",
          updateError.message
        );
      }

      return {
        data,
        error: updateError,
      };
    };

  return {
    user,
    profile,
    logout,
    loading,
    error,

    businessId,
    businessUUID,

    campaignId,
    groupId,

    toolOrder,

    isOwner,
    isAdmin,
    isModerator,

    region,
    language,

    canAccess,
    updateUserSettings,
  };
}